export default "__VITE_ASSET__bf4aefc9__"